import { useState } from 'react';
import { ErrorMessage, Form, Formik } from "formik";
import { Button, CircularProgress } from "@mui/material";
import './index.scss';
import { MessageText } from '../../constants/messageText';
import instance from '../../utils/axiosInstance';
import { ExtendSubscriptionExpiration } from '../../constants/api-urlConstants';
import { apiBasePathUserDetail } from '../../constants/env-url';
import { SnackBarMessage } from '../snackBar/snackBar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

export const UpdateExpiryDay = (props: any) => {
  const { selectedUser, onCancel, onSaveAndClose } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [APIMsgCongig, setAPIMsgCongig] = useState({
    type: '',
    message: '',
    snackFlag: false
  });
  const [open, setOpen] = useState(false);

  const initial_state = {
    expirationDate: selectedUser.expiryDate ? dayjs(selectedUser.expiryDate) : null,
  }

  const setAlertMessage = (type: string, message: string, flag: boolean) => {
    setAPIMsgCongig({
      type: type,
      message: message,
      snackFlag: flag
    });
  }

  const onSubmit = (value: any) => {
    setIsLoading(true);
    const USER_API_BASE_URL = `${apiBasePathUserDetail}${ExtendSubscriptionExpiration}`;
    const userData = {
      userId: selectedUser.id,
      expirationDate: value.expirationDate ? dayjs(value.expirationDate).format("YYYY-MM-DD") : ''
    };
    instance
      .post(USER_API_BASE_URL, userData)
      .then((response: any) => {
        if (response?.data?.success) {
          setAlertMessage('success', MessageText.EXPIRY_DAY_SUCCESS, true);
        }
        setTimeout(() => {
          onSaveAndClose();
        }, 1000);
      })
      .catch(() => {
        setAlertMessage('error', MessageText.EXPIRY_DAY_FAILED, true);
      })
      .finally(() => {
        setIsLoading(false);
        props?.closeConfirmation?.(true);
      });
  }

  return (
    <div className="popupActions">
      <Formik
        enableReinitialize={true}
        initialValues={initial_state}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <div className="update-trial-days-form">
            <Form onSubmit={formik.handleSubmit}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Expiry Date"}
                  value={formik.values.expirationDate}
                  onChange={(value) => formik.setFieldValue('expirationDate', value)}
                  minDate={dayjs()}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      name: 'expirationDate',
                      id: 'expirationDate',
                      onBlur: () => formik.setFieldTouched('expirationDate', true),
                    },
                    field: {
                      onClick: () => setOpen(true),
                    }
                  }}
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                />
              </LocalizationProvider>
              <div className='flex justify-between action'>
                <Button
                  className={props?.buttonName === 'Approve' ? "secondaryBtnGreen" : "secondaryBtn"}
                  onClick={onCancel}
                  style={{ textTransform: "none" }}
                  type='button'
                >
                  Cancel
                </Button>
                {isLoading && <div className="loader">
                  <div>
                    <CircularProgress size={25} />
                  </div>
                </div>
                }
                {!isLoading &&
                  <Button
                    disableElevation
                    autoFocus
                    style={{ textTransform: "none", width: '45%', height: '40px'}}
                    type='submit'
                    disabled={!formik.values.expirationDate || dayjs(formik.values.expirationDate).isBefore(dayjs(), 'day')}
                    variant='contained'
                  >
                    {props?.buttonName ? props?.buttonName : "save"}
                  </Button>
                }
              </div>
            </Form>
          </div>
        )}
      </Formik>
      {APIMsgCongig.snackFlag &&
        <div>
          <SnackBarMessage snacBarValue={APIMsgCongig} />
        </div>
      }
    </div>
  );
}